import styled from 'styled-components';

export const ModuleIconWrapper = styled.div`
  &.module-icon-background {
    padding: 6px;
    border-radius: 8px;
  }
`;
